<section class="ui-page-tabs-header">
  <div class="ui-page-tabs-header__intro">
    <h1 class="ui-page-tabs-header__title">{{ title() | uiLabelTranslate }}</h1>
    @if (description()) {
      <p class="ui-page-tabs-header__description">{{ description() | uiLabelTranslate }}</p>
    }
  </div>

  @if (tabs().length > 0) {
    <div class="ui-page-tabs-header__tabs-row">
      <ui-filter-bar [filters]="tabs()" [selected]="activeTab()" (changed)="onTabSelected($event)"></ui-filter-bar>
      <ng-content select="[tabsActions]" />
    </div>
  }
</section>
